<template>
  <hover-tooltip v-if="short" :tooltip-style="tooltipStyle">
    <v-chip :color="hex" x-small class="white--text rmr-llm-badge">
      {{ shortLabel }}
    </v-chip>
    <template slot="tooltip">{{ label }}</template>
  </hover-tooltip>
  <v-chip
    v-else
    :color="hex"
    :small="size === 'small'"
    :x-small="size === 'x-small'"
    class="white--text rmr-llm-badge"
  >
    {{ label }}
  </v-chip>
</template>

<script>
import HoverTooltip from "@/components/common/HoverTooltip.vue";
import { buildColoredTooltipStyle } from "@/helpers/build-colored-tooltip-style";
import { getLlmDisplayName, getLlmHex, getLlmShortLabel } from "@/helpers/llm-meta";

export default {
  name: "RmrLlmBadge",
  components: { HoverTooltip },
  props: {
    provider: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: "x-small",
      validator: (v) => ["x-small", "small"].includes(v),
    },
    short: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hex() {
      return getLlmHex(this.provider);
    },
    label() {
      return getLlmDisplayName(this.provider);
    },
    shortLabel() {
      return getLlmShortLabel(this.provider);
    },
    tooltipStyle() {
      return buildColoredTooltipStyle(this.hex);
    },
  },
};
</script>
